module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sample__container"
  }, [_c('h3', {
    staticClass: "title is-4 is-marginless"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', {
    staticClass: "title is-6"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-boxed is-marginless"
  }, [_c('ul', [_c('li', {
    class: [_vm.active === 0 ? 'is-active' : '']
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.change(0)
      }
    }
  }, [_c('span', [_vm._v("Result")])])]), _vm._v(" "), _c('li', {
    class: [_vm.active === 1 ? 'is-active' : '']
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.change(1)
      }
    }
  }, [_c('span', [_vm._v("Source")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sample__tabs-body"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "slide-fade"
    }
  }, [(_vm.active === 0) ? _vm._t("result") : (_vm.active === 1) ? _c('div', [_c('pre', [_c('code', [_vm._t("source")], 2)])]) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95e5cd68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/site/Sample.vue
// module id = 49
// module chunks = 2